// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.tab-container[data-v-77f96664] .nav-item.active .nav-link {\n  color: #000;\n}\n.tab-container .nav-link[data-v-77f96664] {\n  padding: 0.5rem 1rem 0.1rem 0 !important;\n  color: #9DA8B7;\n}\n.tab-container .nav-item[data-v-77f96664] {\n  padding: 0.5rem 1rem 0 0 !important;\n}\n.cs-page-buttons[data-v-77f96664] .disabled:nth-child(-n + 2), \n.cs-page-buttons[data-v-77f96664] .disabled:nth-last-child(-n + 2) {\n  display: none !important;\n}\n\n", ""]);
// Exports
module.exports = exports;
